import { parseISO, format } from 'date-fns';

export const formatDate = (value: string, dateFormat: string): string => {
  const date = parseISO(value);
  return format(date, dateFormat);
};

export default formatDate;